import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditDialogComponent } from './edit-dialog.component';
import { VerifyEmailFormModule } from '../verify-email-form/verify-email-form.module';
import { TranslateModule } from '@xref/ngx';
import { DialogCloseModule } from '../dialog-close/dialog-close.module';
import { VerifyCodeFormModule } from '../verify-code-form/verify-code-form.module';

@NgModule({
  declarations: [EditDialogComponent],
  imports: [
    CommonModule,
    VerifyEmailFormModule,
    VerifyCodeFormModule,
    TranslateModule,
    DialogCloseModule
  ],
  exports: [EditDialogComponent]
})
export class EditDialogModule {}
